<template>
  <v-col cols="12 text-center">
    <h3 class="font-weight-bold text-right">
      {{ dataField.title ? dataField.title : "" }}
    </h3>
    <br />
    <v-rating
      v-model="dataPost[fieldName?fieldName.name:dataField.name]"  
      background-color="grey"
      color="warning"
      hover
      length="5"
      size="40"
    ></v-rating>
  </v-col>
</template>

<script>
export default {
  name: "RatingBox",
  props: ["dataField","fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
};
</script>

<style>
</style>
